module.exports = __webpack_public_path__ + "static/logo-f4f37ca5e04156d3eb322547939c26c6.png";